import React from 'react';
import { Button } from '@material-ui/core';
import { ImgLazyload } from '../index';
import { handleSocialMedia } from '../../../../services/helperFunctions';
import WA from '../../../public/images/icon-whatsapp.png';
import FB from '../../../public/images/icon-facebook.png';

export const SocialButton = ({
  type = 'whatsapp',
  text = 'CHAT WITH US',
  className = '',
  btnWidth,
  btnMargin,
  cardType,
  sipCardtype,
  action = '',
  page,
  brRadius,
}) => (
  <Button className={`social-btn ${type} ${action} ${className}`} style={{ width: btnWidth, marginTop: btnMargin, borderRadius: brRadius }} onClick={() => handleSocialMedia(type, action, cardType, sipCardtype, page)}>
    <ImgLazyload src={type == 'whatsapp' ? WA : FB} className="mx-2" />
    <span>{text}</span>
  </Button>
);
 
export default SocialButton;
